import{createContext as t}from"react";const o=t(null);export{o as StoryDetailContext};
